<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div
                class="card-container img-banner bg-100 c_white"
                @click="onClickCard(isVerification)"
            >
                <div class="bh bstart">
                    <div class="b1">
                        <span class="fz_34">我的车主币</span>
                        <span class="fz_28">(个)</span>
                    </div>
                    <div class="fz_28" v-show="!isVerification&&initShow">未认证</div>
                    <div class="ico-whitenext bg-contain" v-show="!isVerification&&initShow"></div>
                </div>
                <div class="money bh">
                    <div class="moneytext b1">
                        <span class="fz_70">{{integer}}.</span>
                        <span class="fz_40">{{decimal}}</span>
                    </div>
                    <div class="moneybtn c_F57 fz_28">去提现</div>
                </div>
                <div class="bh bstart fz_24 moneytilt bh bstart">
                    <div class="bh bstart b1" @click.stop="onClickTips">
                        <div class="icoImg bg-contain ico-money ioc"></div>
                        <div
                            v-show="isVerification"
                        >本月累计提现车主币：{{verificationInfo.withdrawCountThisMonth}}个</div>
                        <div v-show="!isVerification">本月累计提现车主币：0个</div>
                    </div>
                    <div>1车主币=0.93元</div>
                </div>
            </div>

            <div
                class="bh bstart btn-container"
                v-show="isVerification"
                @click="go('UserBankHome')"
            >
                <div class="ico-Bankcard ico bg-contain"></div>
                <div class="b1">
                    <div class="fz_34 c_222">银行卡</div>
                    <div class="fz_28 c_8B8 text">添加我的银行卡</div>
                </div>
                <div class="ico-next bg-contain"></div>
            </div>
            <div
                class="bh bstart btn-container"
                @click.stop="go('UserMoneyHome',{isVerification:isVerification})"
            >
                <div class="ico-Record ico bg-contain"></div>
                <div class="b1">
                    <div class="fz_34 c_222">交易记录</div>
                    <div class="fz_28 c_8B8 text">交易详情({{lastStatus}})</div>
                </div>
                <div class="ico-next bg-contain"></div>
            </div>

            <div class="bh bstart btn-container" @click="go('CommonProblem')">
                <div class="ico-problem ico bg-contain"></div>
                <div class="b1">
                    <div class="fz_34 c_222">常见问题</div>
                    <div class="fz_28 c_8B8 text">什么是车主币？</div>
                </div>
                <div class="ico-next bg-contain"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { user } from "@/mixin/user";
import util from "@/utils/index";
export default {
    mixins: [user],
    name: "MoneyHome",
    data() {
        return {
            // 默认不显示未认证
            initShow: false,
            // 转换为两位小数
            moneyNum: "",
            // 整数
            integer: "",
            // 小数
            decimal: ""
        };
    },
    computed: {
        // 认证信息
        verificationInfo() {
            return this.$store.getters["money/verificationInfo"];
        },
        // 是否通过认证
        isVerification() {
            return this.verificationInfo.verified;
        },
        // 最后状态
        lastStatus() {
            return this.$store.getters["money/lastStatus"];
        },
        // 剩余车主币
        unusedPoints() {
            return this.$store.getters.unusedPoints;
        }
    },
    watch: {
        unusedPoints: {
            handler(v) {
                const me = this;
                // 取小数部分
                me.decimal = v.substr(v.length - 2, 2);
                // 取整数部分
                me.integer = parseInt(v);
            },
            immediate: true
        },
        isVerification: {
            handler(v) {
                // 请求到认证数据状态后再决定是否隐藏或显示未认证状态，避免文字闪屏
                if (util.isBoolean(v)) {
                    this.initShow = true;
                }
                if (v) {
                    // 获取最新提现状态
                    this.$store.dispatch("money/moneyRecord");
                }
            },
            immediate: true
        }
    },
    methods: {
        // 判断是否是已经认证
        userLoginend() {
            this.$store.dispatch("money/verificationInfo");
        },
        onClickCard(v) {
            let to = "MoneyBalance";
            if (!v) {
                to = "MoneyCertification";
            }
            this.go(to);
        },
        // 点击兑换车主币数量弹出框
        onClickTips() {
            this.dialog.alert({
                title: "提示",
                message: `本月累计提现车主币不能超过10w`,
                confirmButtonText: `好的`
            });
        }
    }
};
</script>

<style scoped lang="scss">
@include ico-list(
    "~@/assets/imges/ico/",
    "insurance",
    "money",
    "Bankcard",
    "Record",
    "problem",
    "whitenext"
);
@include img-list("~@/assets/imges/money/", "banner");
.topbar-container {
    .scrollbar-container {
        padding: 24px 30px;
        background-color: #f7f8f8;
    }
    .card-container {
        @include border-radius(12px);
        margin-bottom: 34px;
        padding: 55px 30px 40px 30px;
        position: relative;
        .ico-whitenext {
            width: 12px;
            height: 22px;
            margin: 4px 0 0 20px;
        }
        .money {
            padding: 38px 0 29px 0;
        }
        .moneytilt {
            padding-top: 29px;
            .ioc {
                width: 28px;
                height: 28px;
                margin-right: 10px;
            }
        }
        .moneybtn{
            position: absolute;
            right: -1px;
            padding:17px 34px;
            background-color: #FFFFFF;
            opacity:0.8;
            border-bottom-left-radius: 45px;
            border-top-left-radius: 45px;
        }
    }

    .btn-container {
        @include border-radius(12px);
        background-color: #fff;
        padding: 40px 30px;
        margin-top: 24px;
        .ico {
            width: 62px;
            height: 62px;
            margin-right: 19px;
        }
        .text {
            margin-top: 10px;
        }
        .ico-next {
            width: 18px;
            height: 32px;
        }
    }
}
</style>
